































































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import RoleForm from "@/modules/roles/Form/index.vue";
import {accountJoinRole, accountOutRole, listAccountOfRole} from "@/modules/roles/services";
import {PaginationMeta} from "@/interfaces/common";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeStore} from "@/modules/employees/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {EmployeeType} from "@/enums/type";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 50
    },
    {
        title: "Tài khoản",
        dataIndex: "username",
        key: "username",
        width: 120
    },
    {
        title: "Họ tên",
        dataIndex: "employee.fullname",
        key: "name",
        width: 150
    },
    {
        title: "Số điện thoại",
        dataIndex: "employee.phoneNumber",
        key: "phoneNumber",
        width: 150
    },
    {
        title: "Thao tác",
        dataIndex: "rowGuid",
        key: "rowGuid",
        scopedSlots: { customRender: 'action' },
        width: 120,
        align: "center"
    }
];

@Component({
    name: "RoleUpdate",
    components: {EmployeeSelector, RoleForm}
})
export default class extends mixins(CommonMixin) {
    @Prop()
    readonly id!: number;

    isSubmit = false;
    visible = false;
    columns = columns;
    accounts: Array<Account> = [];
    meta: PaginationMeta = new PaginationMeta();
    EmployeeType = EmployeeType;
    params: any = {
        page: 1,
        limit: 10,
        search: undefined
    };

    employeeRowGuid = "";

    get accountRowGuid() {
        return EmployeeStore.data[this.employeeRowGuid]?.accountRowGuid;
    }

    async created() {
        await this.listAccountOfRole(this.id, this.params);
    }

    get pagination() {
        return {
            current: this.meta.page,
            pageSize: this.meta.limit,
            total: this.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} nhân viên`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    async onConfirm(rowGuid: string) {
        try {
            await accountOutRole({ roleId: this.id, accountRowGuid: rowGuid });
            this.accounts.splice(this.accounts.findIndex((item: any) => item.rowGuid === rowGuid), 1);
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi")
        }
    }

    async submit() {
        try {
            this.isSubmit = true;
            const { data } = await accountJoinRole({ accountRowGuid: this.accountRowGuid, roleId: this.id });
            this.accounts.push(data.data);
            this.$message.success("Thêm nhân viên vào nhóm quyền thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
        this.isSubmit = false;
    }

    async listAccountOfRole(id: any, params: any) {
        const { data } = await listAccountOfRole(id, params);
        this.accounts = data.datas?.map((item: any, index: number) => ({ ...item, stt: index + 1 }));
        this.meta = data?.meta;
    }

    onChangePage(pagination: any) {
        this.listAccountOfRole(this.id, { ...this.params, page: pagination.current, limit: pagination.pageSize });
    }
}
